/**
 * @readonly
 * @enum {string}
 */
export const TpmsAxleTypes = Object.freeze({
    DRIVE: 'DRIVE',
    LIFT: 'LIFT',
    STEER: 'STEER',
    STEER_DRIVE: 'STEER_DRIVE',
    SPARE_TIRE: 'SPARE_TIRE',
    TAG: 'TAG',
    TRAILER: 'TRAILER',
    TRAILER_LIFT: 'TRAILER_LIFT',
    TRAILER_STEER: 'TRAILER_STEER'
})
